import apolloClient from '../../utils/apollo-client';
import { getMakes } from '../graphql/car-search';

export default async function getMakesApi() {
  const response = await apolloClient().then((client) =>
    client.query({
      query: getMakes
    })
  );
  return response.data.makes;
}
